import Timeline from './Timeline';
export default Timeline;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/timeline/index.js
// module id = 847
// module chunks = 0